import NavigationProvider from './navigation/navigation.provider';

const RootProvider = ({ children }) => {
  return <NavigationProvider>{children}</NavigationProvider>;
};

export default RootProvider;
